module.exports = __webpack_public_path__ + "static/img/northFace3.1407943.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/northFace3.png
// module id = P2rl
// module chunks = 2